import { render, staticRenderFns } from "./SearchIdVenta.vue?vue&type=template&id=77d988a3&lang=pug&"
import script from "./SearchIdVenta.vue?vue&type=script&lang=js&"
export * from "./SearchIdVenta.vue?vue&type=script&lang=js&"
import style0 from "./SearchIdVenta.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SearchIdVenta.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
installComponents(component, {
  VBtn,
})
